var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD",
    transform: "translate(-1280.000000, -3150.000000)",
    fill: "#DBA45C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4F4D\\u56FE\\u5907\\u4EFD",
    transform: "translate(0.000000, 3110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14",
    transform: "translate(1031.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_medium",
    transform: "translate(249.014824, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.992588,0 C8.9520383,0 0,8.95535714 0,20 C0,31.0446429 8.9520383,40 19.992588,40 C31.0331377,40 39.985176,31.0446429 39.985176,20 C39.985176,8.95535714 31.0331377,0 19.992588,0 Z M31.416924,11.3258929 L29.5961705,13.0714286 C29.4355158,13.1919643 29.359651,13.3883929 29.3908894,13.5803571 L29.3908894,26.4241071 C29.359651,26.6205357 29.4355158,26.8169643 29.5961705,26.9330357 L31.381223,28.6785714 L31.381223,29.0669643 L22.4202594,29.0669643 L22.4202594,28.6964286 L24.2633261,26.90625 C24.446294,26.7232143 24.446294,26.6696429 24.446294,26.3973214 L24.446294,16.0044643 L19.3142681,29.0223214 L18.6225602,29.0223214 L12.6515596,16.0044643 L12.6515596,24.7321429 C12.598008,25.0982143 12.7274243,25.46875 12.9862569,25.7321429 L15.3871526,28.6383929 L15.3871526,29.0267857 L8.56825201,29.0267857 L8.56825201,28.6383929 L10.9691476,25.7321429 C11.2279802,25.46875 11.339546,25.09375 11.2815318,24.7321429 L11.2815318,14.6428571 C11.3127702,14.3616071 11.2056671,14.0892857 10.9914608,13.8973214 L8.85832304,11.3258929 L8.85832304,10.9375 L15.4853305,10.9375 L20.5995059,22.1651786 L25.1023008,10.9464286 L31.416924,10.9464286 L31.416924,11.3258929 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic_medium.d5faf99d78ce77391e1ea3c3bfa713f2.svg";
export { ForwardRef as ReactComponent };